export const INVESTIGATION_DETAILS_QUERY_KEY = "get-investigation-details";
export const INVESTIGATION_EVENTS_QUERY_KEY = "investigation-events";
export const INVESTIGATION_DRAWER_EVENTS_QUERY_KEY = "investigation-drawer-events";
export const INVESTIGATION_DRAWER_LOGS_QUERY_KEY = "investigation-drawer-logs";
export const investigationDetailsQueryKey = (investigationId, includeLogsAndEvents = false) => investigationId ? [INVESTIGATION_DETAILS_QUERY_KEY, investigationId, includeLogsAndEvents] : [INVESTIGATION_DETAILS_QUERY_KEY];
export const investigationEventsQueryKey = (...parts) => [INVESTIGATION_EVENTS_QUERY_KEY, ...parts];
export const investigationDrawerEventsQueryKey = (...parts) => [
  INVESTIGATION_DRAWER_EVENTS_QUERY_KEY,
  ...parts
];
export const investigationDrawerLogsQueryKey = (...parts) => [
  INVESTIGATION_DRAWER_LOGS_QUERY_KEY,
  ...parts
];
